export default (state, action) => {
  const {
    payload: { materialId, patch, updatedMaterial, oldMaterial },
  } = action;

  switch (action.status) {
    case 'started':
      return {
        ...state,
        [materialId]: {
          ...state[materialId],
          ...patch,
        },
      };
    case 'success':
      return {
        ...state,
        [materialId]: updatedMaterial,
      };
    case 'error':
    default:
      return {
        ...state,
        [materialId]: oldMaterial,
      };
  }
};
